export default __webpack_public_path__ + "static/media/icon-redirect-5.630a0108.svg";